import { useCallback, useEffect, useState } from 'react';
import AppleSignin, {
  AppleAuthResponse as AppleAuthResponseFromLib,
  AppleSignInButtonProps,
} from 'react-apple-signin-auth';
import { twMerge } from 'tailwind-merge';

import { APPLE_OAUTH_REDIRECT_URL } from '@/shared/config';
import { useDeviceType } from '@/shared/hooks/useDeviceType';

import { isSafari } from '../lib/env';

type AppleOauthButtonProps = {
  className?: string;
} & Pick<AppleSignInButtonProps, 'onSuccess' | 'onError'>;

export type AppleAuthResponse = AppleAuthResponseFromLib;

export function useIsSupportedAppleOauthButton(onlyClientRender = false) {
  const deviceType = useDeviceType(onlyClientRender);
  const checkIsSupported = useCallback(
    (type: ReturnType<typeof useDeviceType>) => {
      if (type === 'iOS') {
        return true;
      }

      return type === 'Mac' && isSafari();
    },
    []
  );
  const [isSupported, setIsSupported] = useState(checkIsSupported(deviceType));

  useEffect(() => {
    setIsSupported(checkIsSupported(deviceType));
  }, [deviceType, checkIsSupported]);

  return isSupported;
}

export default function AppleOauthButton({
  className = '',
  ...props
}: AppleOauthButtonProps) {
  return (
    <AppleSignin
      className={twMerge('!rounded-lg', className)}
      authOptions={{
        clientId: 'app.bumpy',
        scope: 'email',
        redirectURI: APPLE_OAUTH_REDIRECT_URL,
        state: 'state',
        nonce: 'nonce',
        usePopup: true,
      }}
      uiType='light'
      {...props}
    />
  );
}
